module.exports = __webpack_public_path__ + "img/cantalagua.3fa224df.jpg";